import axios from '@/plugins/axios'

/**
 * 获取账单列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getBillList(params) {
  return axios({
    url: '/mp/bill/list',
    method: 'get',
    params
  })
}

/**
 * 获取账单详情
 * @param {String} id - 账单ID
 * @returns {Promise}
 */
export function getBillDetail(id) {
  return axios({
    url: `/mp/bill/${id}`,
    method: 'get'
  })
}


export function updateBill( data) {
  return axios({
    url: `/mp/bill/`,
    method: 'put',
    data
  })
}



/**
 * 获取支付状态
 * @param {String} id - 账单ID
 * @returns {Promise}
 */
export function getPayStatus(id) {
  return axios({
    url: `/mp/bill/pay/status/${id}`,
    method: 'get'
  })
}


export function submitPay(id) {
  return axios({
    url: `/mp/bill/pay/${id}`,
    method: 'post'
  })
}

